import { useEffect, useState } from "react";

// True on phone-sized viewports, where fixed trays and sticky panels fight for space.
export default function useIsCompact(query = "(max-width: 640px)") {
  const [compact, setCompact] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e) => setCompact(e.matches);
    mq.addEventListener("change", onChange);
    setCompact(mq.matches);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);

  return compact;
}
